<template>
    <nav
        v-if="list"
        class="nav-main"
        :class="{ 'nav-main--opened' : navIndexOpened >= 0 }"
        v-click-outside="hideChilds"
    >
        <ul class="nav-main__list">
            <li
                :key="indexA"
                class="nav-main__item"
                v-for="(itemA, indexA) in list"
                :class="[
                    'nav-main__item',
                    { 'is-opened' : indexA === navIndexOpened }
                ]"
            >
                <a
                    :href="itemA.link"
                    v-html="itemA.name"
                    @click="showChilds($event, indexA, itemA)"
                    :class="[
                        'nav-main__link nav-main__link--1',
                        { 'is-active' : itemA.active },
                    ]"
                ></a>

                <div class="nav-main__childs" v-if="itemA.items">
                    <div class="nav-main-childs">
                        <button @click="hideChilds" class="nav-main-childs__close">
                            <z-icon name="close" width="24" height="24" />
                        </button>
                        <p class="nav-main-childs__title" v-html="itemA.name"></p>
                        <ul class="nav-main-childs__list">
                            <li
                                class="nav-main-childs__item"
                                v-for="(itemB, indexB) in itemA.items"
                                :key="indexB"
                            >
                                <a
                                    :class="[
                                        'nav-main-childs__link',
                                        { 'is-active' : itemB.active },
                                    ]"
                                    :href="itemB.link"
                                    v-html="itemB.name"
                                >
                                    <span v-html="itemB.name"></span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'nav-main',
    data () {
        return {
            navIndexOpened: -1,
            navChildsIndexOpened: -1,
            indexOfOpendItem: -1
        }
    },
    computed: {
        list () {
            if (!this.$root.app.components.navigation) return
            return this.$root.app.components.navigation.top
        }
    },
    methods: {
        ...mapActions(['MenuOpen']),
        buildTarget (href) {
            return /^http|^\/\//.test(href) ? '_blank' : '_self'
        },
        showChilds (event, i, item) {
            event.preventDefault()
            if ((this.indexOfOpendItem >= 0 && this.indexOfOpendItem === i) || !item.items?.length) {
                window.location = item.link
            }

            if (!item.hasOwnProperty('items')) {
                this.hideChilds()
            } else if (item.hasOwnProperty('items') && this.navIndexOpened !== i) {
                this.MenuOpen(true)
                this.navIndexOpened = i
                this.navChildsIndexOpened = -1
                this.indexOfOpendItem = i
                this.$root.$bus.$emit('navigation-open')
                document.querySelector('body').classList.add('nav-opened')
            }
        },
        showSubChilds (event, i, item) {
            if (this.navChildsIndexOpened !== i) {
                this.navChildsIndexOpened = i
            }
        },
        hideChilds () {
            this.MenuOpen(false)
            this.navIndexOpened = -1
            this.indexOfOpendItem = -1
            this.navChildsIndexOpened = -1
            this.$root.$bus.$emit('navigation-close')
            document.querySelector('body').classList.remove('nav-opened')
        },
        clearHide (data) {
            if (data) return data.filter(item => !item.hide)
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
